import {Group} from "three";
import {posix} from "path";
import axios from 'axios';

export class Checkout{

    public static instance = new Checkout();

    private csrfToken ='';

    private constructor(){
    }

    public getCSRFToken():string {
        return this.csrfToken
    }

    public seCSRFToken(token:string){
        this.csrfToken = token;
    }

    public checkOut(){
        /*let postData = [];
        postData.push("sAdd = 01010015");
        postData.push("sQuantity = 1");
        postData.push("__csrf_token = Q2RqN7PAa8EmxTLjnlTbdQQZIXvuGU");
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "https://cors-anywhere.herokuapp.com/https://www.schickling-grill.de/checkout/addArticle", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send(postData.join("&"));*/

        let bodyData = new FormData();
        bodyData.append("sAdd", "01010015");
        bodyData.append("sQuantity", "1");
        bodyData.append("__csrf_token", "Q2RqN7PAa8EmxTLjnlTbdQQZIXvuGU");
        const cre = btoa(unescape(encodeURIComponent('VisCircle:GrillKonfigurator')));
        axios.post('https://cors-anywhere.herokuapp.com/https://www.schickling-grill.de/checkout/addArticle',bodyData, {headers: { "X-Requested-With" : "XMLHttpRequest",'content-type': 'multipart/form-data',"Authorization" : `Basic ` + cre }})
            .then(()=>{
                // console.log("DONE")
            })
            .catch((e)=>{
                // console.log("ERROR: ", e)
            })

    }

    public getHTTP() {
        const cre = btoa(unescape(encodeURIComponent('VisCircle:a5UhmLbigTPA0ZorLvdOwWqMhdt13dxCFZfsxck7')));
        axios.get("https://schickling-grill.de/api/articles/01010080?useNumberAsId=true", { headers: {"Authorization" : `Basic ` + cre} })
            .then((result)=>{
                // console.log(result.data);
            })

        //localStorage.getItem('test');

            //var mywindow = window.open("https://www.schickling-grill.de/grill/kugelgrill/hybridgrill/98/kugelgrill-kohga-deluxe-kohle-gas");

            // register an onload event with the popup window so that we attempt to
            // modify it's DOM only after it's onload event fires.

    }


}

//'https://cors-anywhere.herokuapp.com/https://www.schickling-grill.de/grill/kugelgrill/hybridgrill/98/kugelgrill-kohga-deluxe-kohle-gas'